import { Component, OnInit, ViewChild } from '@angular/core';
import { combineAll, DcBaseComponent } from '@datachain/ui-sdk/common';
import { IBreadCrumbEntry } from '@datachain/ui-sdk/components/breadcrumb';
import { Store } from '@ngrx/store';
import { DxDataGridComponent } from 'devextreme-angular';
import {
	BehaviorSubject,
	firstValueFrom,
	Observable,
	takeUntil,
	tap,
} from 'rxjs';

import { goToHdHome, goToProjects } from '../../../core/store';
import { DcLoaders } from '../../../ui/app-loaders';
import {
	ExpositionsSelector,
	goToMigrationsModalRoute,
	initMigratedExpositionsList,
	refreshMigratedExpositionsList,
} from '../../store';
import { MigratedExpositionListEntity } from './migrated-exposition-list.entity';

@Component({
	selector: 'app-exposition-migrations-list',
	templateUrl: './exposition-migrations-list.component.html',
	styleUrls: ['./exposition-migrations-list.component.scss'],
	inputs: ['projectLabel'],
})
export class ExpositionMigrationsListComponent
	extends DcBaseComponent
	implements OnInit
{
	@ViewChild('expositionMigratedListDatagrid')
	protected readonly DcLoaders = DcLoaders;
	public paths: Array<IBreadCrumbEntry> = [];

	public vo$: Observable<{
		isFirstLoad: boolean;
		list: MigratedExpositionListEntity;
	}>;

	private readonly migratedExpoListGridCmp: DxDataGridComponent | null = null;

	private readonly firstLoadSubject = new BehaviorSubject<boolean>(true);

	public constructor(
		private readonly store: Store,
		private readonly selector: ExpositionsSelector
	) {
		super();

		this.vo$ = combineAll({
			isFirstLoad: this.firstLoadSubject,
			list: this.selector.getMigratedExpositions$(),
		});
	}

	public ngOnInit(): void {
		this.store.dispatch(initMigratedExpositionsList());

		combineAll({
			projectLabel: this.toObservable<string>('projectLabel'),
		})
			.pipe(
				takeUntil(this.onDestroy$),
				tap(({ projectLabel }) => {
					this.paths = [
						{
							label: $localize`:i18n=@@general.projects:`,
							isActive: true,
							callback: (): void => this.store.dispatch(goToProjects()),
						},
						{
							label: projectLabel,
							isActive: true,
							callback: (): void => this.store.dispatch(goToHdHome()),
						},
						{
							label: $localize`:i18n=@@expositions.breadcrumb.list:`,
							isActive: false,
							callback: (): void => {},
						},
					];
				})
			)
			.subscribe();
	}

	public goToMigrationsModalRoute(): void {
		this.store.dispatch(goToMigrationsModalRoute());
	}

	public refreshMigratedExpositionList(): void {
		this.store.dispatch(refreshMigratedExpositionsList());
	}

	public searchMigrated(searchTerm: string): void {
		if (!this.migratedExpoListGridCmp) {
			return;
		}
		this.migratedExpoListGridCmp.instance.searchByText(searchTerm);
	}

	public async onGridContentReady(): Promise<void> {
		const firstLaod = await firstValueFrom(this.firstLoadSubject);

		if (firstLaod) {
			this.firstLoadSubject.next(false);
		}
	}
}
